import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ns-fund-by-invest',
  template: require('./fund-by-invest.component.html')
})

export class FundByInvestComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    this.stepNum = '5';
    this.funtReqURL = `${this.flowManager.config.investDocsRoot}journal-request`;
    this.nextBtnText = 'Next';
    this.flowManager.fundingMethod = 'journal request';
  }

  ngOnInit() {
    this.authenticated = this.flowManager.isAuthed;
    this.isStreamline = this.appActions.getData('Streamline');
    if (this.authenticated) {
      this.nextBtnText = 'Go to Accounts';
    }

    this.form = {
      stepTitle: 'Fund Your Account'
    };
  }

  btnClick(e) {
    if (e === 'next') {
      if (this.authenticated) {
        this.loadingNext = true;
        this.flowManager.ssoToAlly();
      } else {
        this.router.navigate(['/credentials']);
      }
    } else if (e === 'back') {
      if (this.authenticated && this.isStreamline) {
        this.router.navigate(['/funding-choices-streamline']);
      } else {
        this.router.navigate(['/funding-choices']);
      }
    }
  }
}
